import { render, staticRenderFns } from "./authorize-attendances.vue?vue&type=template&id=4e193942"
import script from "./authorize-attendances.vue?vue&type=script&lang=js"
export * from "./authorize-attendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports